import React from 'react';
import styled, { keyframes } from 'styled-components';
import {FormattedMessage} from 'react-intl';

const RecoloringLoader = ({className}) => {

    const transition = keyframes`
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
    `;

    const InnerLoader = styled.div`
        margin: 0 auto;
        font-size: ${props => props.theme.fontSizes[11]};
        font-family: ${props => props.theme.condensed};
        display: flex;
        flex-direction: column;
        justify-content: center;
      
        & .loading {
            margin: 0 auto;
        }
        
        & .loading span {
            display: inline-block;
            vertical-align: middle;
            width: 1rem;
            height: 1rem;
            margin: .31rem;
            margin: .31rem;
            background: #b30059;
            border-radius: .6rem;
            animation: ${transition} 1.2s infinite alternate;
          }
        }
      
      & .loading span:nth-of-type(2) {
        background: #e60073;
        animation-delay: 0.2s;
      }
      & .loading span:nth-of-type(3) {
        background: #ff3399;
        animation-delay: 0.4s;
      }
      & .loading span:nth-of-type(4) {
        background: #00E5FF;
        -webkit-animation-delay: 0.6s;
        animation-delay: 0.6s;
      }
      & .loading span:nth-of-type(5) {
        background: #ff3399;
        animation-delay: 0.8s;
      }
      & .loading span:nth-of-type(6) {
        background: #e60073;
        animation-delay: 1.0s;
      }
      & .loading span:nth-of-type(7) {
        background: #b30059;
        animation-delay: 1.2s;
      }
`;

    return (
        <div className={className}>
            <InnerLoader>
                <div className="loading">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <p>
                    <FormattedMessage
                        id="RECOLORING_LOADER_TEXT"
                        defaultMessage="Wir mixen die Farben ..."
                    />
                </p>
            </InnerLoader>
        </div>
    );
};

export default RecoloringLoader;



// WEBPACK FOOTER //
// ./src/components/pattern/RecoloringLoader.js